import GoChevronDown from '@meronex/icons/go/GoChevronDown';
import icon from './StyledIcon';
export default icon(GoChevronDown);
